import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { LoadingSpinnerComponent } from './loading-spinner/loading-spinner.component';
import { SharedModule } from '../shared/shared.module'
import { TranslateModule } from '../shared/services/translate';

@NgModule({
  declarations: [
    LoadingSpinnerComponent,
  ],
  imports: [
    CommonModule, 
    TranslateModule,
    SharedModule,
  ],
  providers: [],
  exports: [
    LoadingSpinnerComponent,
  ]
})
export class LoadingSpinnerModule { }
